import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Http, Headers } from '@angular/http';
import { NavigationExtras, Router } from '@angular/router';
import { AppSettings } from '../constants/contants';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import * as XLSX from 'xlsx';
@Injectable({
  providedIn: 'root'
})
export class LoginserviceService {

  public islogin: boolean = false;

  serviceloginChange: Subject<boolean> = new Subject<boolean>();
  serviceAuthChange: Subject<boolean> = new Subject<boolean>();

  companyid: number = 0;
  companyColl: any = [];

  userBO: any = {};
  userrolerightsColl: any = [];
  userView: any = {};

  fileName= 'Export.xlsx';
  
  constructor(private http: Http, public router: Router, private toastr: ToastrService, private confirmationDialogService: ConfirmationDialogService) {

  }


  fnpostInputParams(url, params) {
    const headers = new Headers({
      //'Content-Type': "application/JSON",
      'authkey': (sessionStorage.authkey === undefined) ? 1 : JSON.parse(sessionStorage.authkey),
      'token': (sessionStorage.hrtoken === undefined) ? '' : JSON.parse(sessionStorage.hrtoken)
    });

    return this.http.post(url, params, { headers: headers });
  }


  //Get UserRole List
  fnGetUserRoleList() {
    var data = {
      'userid': 0,
    }

    this.fnpostInputParams(AppSettings.getUserRoleRightsUserUrl, data)
      .subscribe(
        (res) => {


          if (res.json().status == 200) {
            var _res = res.json().result;

            if (_res.length) {


              if (_res[0].length > 0) {
                this.userBO = _res[0][0];
                this.companyid = this.userBO.companyid;
              }
              else {
                this.userBO = {};
              }

              this.userrolerightsColl = _res[1];
            }

            this.userView = {
              userBO: this.userBO,
              userrolerightsColl: this.userrolerightsColl
            }

            this.serviceAuthChange.next(true);
            this.serviceloginChange.next(this.userView);
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {

          this.fnShowErrorMsg('Error' + err);
        })

  }


  getCompany(params) {
    const headers = new Headers({
      'Content-Type': "application/JSON",
      'authkey': (sessionStorage.authkey === undefined) ? 1 : JSON.parse(sessionStorage.authkey)
    });
    return this.http.post(AppSettings.getCompanyUrl, params, { headers: headers });
  }



  fnCheckCompany() {

    if (this.companyid == 0) {
      return false;
    }
    else if (this.companyid > 0) {
      return true;
    }

  }
  fnCheckLogin() {
    if (sessionStorage.hrtoken === undefined) {
      this.router.navigate(['/Login']);
    }

  }

  fnCompanyFaildRedirect() {

  }

  fnGetCompanyId() {
    return this.companyid;
  }


  fnGetModUserId() {
    if (this.userBO.userid) {
      return this.userBO.userid;
    }
    else {
      return 0;
    }
  }


  fnCheckUserRoleAction(formname, action) {

    if (this.userrolerightsColl) {

      const index = this.userrolerightsColl.findIndex(abo => abo.userappformname.toUpperCase() === formname.toUpperCase());
      if (index > -1) {
        var _pBO = this.userrolerightsColl[index];


        if (action === 'CREATE' && _pBO.uappcreate) {
          return true;
        }
        else if (action === 'ALTER' && _pBO.uappalter) {
          return true;
        }
        else if (action === 'DELETE' && _pBO.uappdelete) {
          return true;
        }
        else if (action === 'VIEW' && _pBO.uappview) {
          return true;
        }
        else if (action === 'PRINT' && _pBO.uappprint) {
          return true;
        }
        else if (action === 'EXPORT' && _pBO.uappexport) {
          return true;
        }
        else if (action === 'APPROVE' && _pBO.uappapproval) {
          return true;
        }
        else if (action === 'REJECT' && _pBO.uappreject) {
          return true;
        }
        else if (action === 'PAYMENT' && _pBO.uapppayment) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }

    } else {
      return false;
    }
  }

  fnCheckUserRoleAll(formname) {

    if (this.userrolerightsColl) {

      const index = this.userrolerightsColl.findIndex(abo => abo.userappformname === formname);
      if (index > -1) {
        var _pBO = this.userrolerightsColl[index];

        if (_pBO.uappcreate || _pBO.uappalter || _pBO.uappdelete || _pBO.uappview || _pBO.uappprint || _pBO.uappexport) {
          return true;
        }
        else {
          return false;
        }
      }
    } else {
      return false;
    }
  }


  fnAPIError(data) {

    console.log(data)

    if (data.statuscode === 400) {
      if (data.message === "AUTH INVALID") {
        this.fnCompanyFaildRedirect();
      }

      if (data.err_field) {
        alert(data.err_field);
        //this.toastr.error('Error', data); 
      }
    }


    if (data.status === 400) {
      if (data.err_field) {
        this.toastr.error('Error', data.err_field);
      }
    }



  }


  fnConfirmFormLeave(): Promise<boolean> {

    return this.confirmationDialogService.confirm('Confirm..', 'Do you  want to leave this page?')
      .then((confirmed) => {
        if (confirmed) {
          return true;
        }
        else {
          return false
        }

      }
      );


  }



  fnDatePickerOpen(datepicker) {
    if (datepicker) {

      datepicker.toggle();

    }
  }


  fnDatePickerClose(event, datepicker) {
    if (event.relatedTarget) {
      if (event.relatedTarget.parentNode.nodeName !== 'BS-DATEPICKER-NAVIGATION-VIEW') {
        datepicker.hide();
      }
    }
  }


  fnCloseCommonForm(menu) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'menu': menu,
      }
    }



    this.router.navigate(['/SettingsMenu'], navigationExtras).then(() => {


    });
  }

  fnCompareDateValidation(fromdate, todate) {
    if (Date.parse(fromdate.toDateString()) < Date.parse(todate.toDateString())) {
      return true
    }
    else {
      return false
    }

  }

  fnLastDate(indate) {
    let lastdate = null;
    if (indate) {
      lastdate = new Date(
        indate.getFullYear(),
        indate.getMonth() + 1,
        0
      );
    }

    return lastdate;
  }

  fnOpenMonthCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(this.fnLastDate(event.date)));
    };     
    container.setViewMode('month');
  }

  fnCheckFornControlNotfound(fc) {
    let ischeck = false;
    const validator = fc;
      
    if (validator.errors) {
      if (validator.errors.notfound) {
        ischeck = true;
      }         
    }

    return ischeck;
  }  

  fnSetFirstControlFocus(controlnanme) {
    try{
      setTimeout(() => {
        document.getElementById(controlnanme).focus();  
      }, 500);
      
    }
    catch{

    }

  }
  exportexcel(filename): void
  
  {
   
    /* pass here the table id */
    let element = document.getElementById('exportlist');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, filename);
 
    /* save to file */  
    XLSX.writeFile(wb, filename+'.xlsx');
 
  }
  private fnShowErrorMsg(ex) {
    console.log(ex);
  }


}
